module.exports = __webpack_public_path__ + "static/img/signet-ca.c3118749.png";